import '../../style.css'
import { SearchOutlined } from '@ant-design/icons'
import { infoSite } from '../../../../state/atom'
import { useRecoilValue } from 'recoil'

export const SearchButton = (e: any) => {
  const info = useRecoilValue(infoSite)

  const c = info.Colore.Rgba

  return (
    <div
      onClick={() => e.func('active')}
      className="SearchButton"
      style={{ backgroundColor: `rgba(${c.r},${c.g},${c.b},${c.a})` }}
    >
      <SearchOutlined className="Icon" style={{ color: 'white' }} />
    </div>
  )
}
